import { ApiClient } from '@mezo/web/api-client';
import { OperationConfig } from '@reshub/dtos';
import { useQuery } from 'react-query';

export const getBrandingConfigForCustomerForChat = async (customerId: string) => {
  const { data } = await ApiClient.CHAT_API.utility.get(`/customers/${customerId}/configuration/branding`);
  return data;
};

export const getBrandingConfigForUnitForChat = async (unitId: string) => {
  const { data } = await ApiClient.CHAT_API.utility.get(`/unit/${unitId}/config/branding`);
  return data;
};

export const getBrandingConfigurationForChat = async (configurationId: string) => {
  const { data } = await ApiClient.CHAT_API.utility.get(`/configuration/${configurationId}/branding`);
  return data;
};

export const usePlatformConfigForChat = () => {
  return useQuery(
    ['platformOperationConfig'],
    async () => {
      const { data } = await ApiClient.CHAT_API.utility.get<OperationConfig>(`/configuration/operation`);
      return data;
    },
    { enabled: true }
  );
};
